/**
 * Escape wishlist — localStorage + optional customer metafield hydrate.
 * Cross-device write needs a wishlist app / customer metafield writer.
 */
const STORAGE_KEY = "escape-wishlist";
const CUSTOMER_JSON_ID = "escape-wishlist-customer";

function readIds() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(raw) ? raw.map(String) : [];
  } catch {
    return [];
  }
}

function writeIds(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(ids.map(String))]));
}

function hydrateFromCustomer() {
  const el = document.getElementById(CUSTOMER_JSON_ID);
  if (!el) return;
  try {
    const remote = JSON.parse(el.textContent || "[]");
    if (!Array.isArray(remote) || !remote.length) return;
    writeIds([...readIds(), ...remote.map(String)]);
  } catch {
    /* ignore bad merchant metafield payload */
  }
}

function isSaved(id) {
  return readIds().includes(String(id));
}

function toggle(id) {
  const sid = String(id);
  const ids = readIds();
  const next = ids.includes(sid) ? ids.filter((x) => x !== sid) : [...ids, sid];
  writeIds(next);
  return next.includes(sid);
}

function syncButton(btn) {
  const id = btn.dataset.productId;
  if (!id) return;
  const saved = isSaved(id);
  btn.classList.toggle("is-saved", saved);
  btn.setAttribute("aria-pressed", saved ? "true" : "false");
  const labelSave = btn.dataset.labelSave || btn.getAttribute("aria-label") || "Save to wishlist";
  const labelSaved = btn.dataset.labelSaved || "Saved";
  btn.setAttribute("aria-label", saved ? labelSaved : labelSave);
  const label = btn.querySelector("[data-wishlist-label]");
  if (label) {
    label.textContent = saved ? labelSaved : labelSave;
  }
}

function onClick(event) {
  const btn = event.target.closest("[data-escape-wishlist]");
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  const id = btn.dataset.productId;
  if (!id) return;
  toggle(id);
  syncButton(btn);
  const sid = String(id);
  document.querySelectorAll("[data-escape-wishlist]").forEach((other) => {
    if (other.dataset.productId === sid) syncButton(other);
  });
}

function init() {
  hydrateFromCustomer();
  document.querySelectorAll("[data-escape-wishlist]").forEach(syncButton);
  document.addEventListener("click", onClick);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

export { isSaved, toggle, readIds };
